export let DOMAIN = 'vssplandyn.carpostal.fr'